const AudioPlayer = (target) => {
  const initAudio = el => {
    const audioPlayer = el
    const audio = new Audio(
      el.dataset.audio
    );

    audio.addEventListener('loadeddata', () => {
      audio.volume = .75;
    }, false);

    //click on timeline to skip around
    const timeline = audioPlayer.querySelector('.audio-player__timeline');
    timeline.addEventListener('click', e => {
      const timelineWidth = window.getComputedStyle(timeline).width;
      const timeToSeek = e.offsetX / parseInt(timelineWidth) * audio.duration;
      audio.currentTime = timeToSeek;
    }, false);

    //check audio percentage and update time accordingly
    setInterval(() => {
      const progressBar = audioPlayer.querySelector('.audio-player__progress');
      progressBar.style.width = audio.currentTime / audio.duration * 100 + '%';
    }, 500);

    //toggle between playing and pausing on button click
    const playBtn = audioPlayer.querySelector('.audio-player__toggle');
    playBtn.addEventListener(
      'click',
      () => {
        if (audio.paused) {
          audioPlayer.classList.add('audio-player--playing');
          audio.play();
        } else {
          audioPlayer.classList.remove('audio-player--playing');
          audio.pause();
        }
      },
      false
    );
  };


  $('body').find(target)
    .each((_, el) => {
      initAudio(el);
    });
}

export default AudioPlayer


// WEBPACK FOOTER //
// ./scripts/components/AudioPlayer.js